export const specialCharRemove = (value: string) => {
  return value.replace(/[^a-zA-Z0-9 ]/g, '');
}

export const isValidString = (input: string): boolean => {
  const regex = /^[A-Za-zÀ-ÖØ-ÿ0-9'.\- ]+$/;
  return regex.test(input);
}
